module.exports = __webpack_public_path__ + "a1747e5ceb94f91c2264fecebb639d0f.png";